import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "aba3550d-79e1-46fd-ad92-5e0633927efb", content: "High total surface mass", options: {} },
  {
    id: "c6d2fe49-e038-454a-90db-9f71d54143eb",
    content: "One or more layers of thin, but dense material",
    options: {},
  },
  {
    id: "f7911683-55ed-4671-b073-cc492e3ae7b3",
    content: "Single or double seals all around the door frame",
    options: {},
  },
  { id: "776b56bd-d926-45c4-8d1e-e1a0945a1e99", content: "Strict installation procedures", options: {} },
  { id: "2a0d95a8-20a8-4834-a6a4-21012975d002", content: "Loose fit to the door frame", options: {} },
  { id: "9435abfe-b63f-4a48-8f6a-ed83ecc392dc", content: "Open keyhole", options: {} },
  { id: "3b6e0162-e1e4-4f52-a34a-ef0a1c669bc5", content: "No threshold", options: {} },
  { id: "548920a3-95fb-45fe-aac3-da6fd77aa804", content: "Honeycomb cardboard core", options: {} },
];

const groups = [
  { id: "dc7028eb-1cc3-4956-a66e-e71a628376a2", content: "Good sound insulation", options: {} },
  { id: "4600679a-53d9-49ac-9ffc-130f4c5b4ea7", content: "Bad sound insulation", options: {} },
];

export const task: Task = {
  id: "96343b4c-daf5-4317-98dd-8c67adabb350",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "dc7028eb-1cc3-4956-a66e-e71a628376a2",
      itemsId: [
        "aba3550d-79e1-46fd-ad92-5e0633927efb",
        "c6d2fe49-e038-454a-90db-9f71d54143eb",
        "f7911683-55ed-4671-b073-cc492e3ae7b3",
        "776b56bd-d926-45c4-8d1e-e1a0945a1e99",
      ],
    },
    {
      groupId: "4600679a-53d9-49ac-9ffc-130f4c5b4ea7",
      itemsId: [
        "2a0d95a8-20a8-4834-a6a4-21012975d002",
        "9435abfe-b63f-4a48-8f6a-ed83ecc392dc",
        "3b6e0162-e1e4-4f52-a34a-ef0a1c669bc5",
        "548920a3-95fb-45fe-aac3-da6fd77aa804",
      ],
    },
  ],
};
